import { IconToggleHeartOff12, IconToggleHeartOn12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './FavoriteButton.css';

export interface IFavoriteButtonProps {
  isActive: boolean;
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const FavoriteButton: React.FC<IFavoriteButtonProps> = ({ isActive, onClick }) => {
  return (
    <button className={styles['favorite-button']} title="Избранное" onClick={onClick}>
      <span className={styles['icon-wrapper']}>
        {isActive ? (
          <IconToggleHeartOn12 color="icon-negative-default" aria-label="heartActive" />
        ) : (
          <IconToggleHeartOff12 color="icon-secondary-default" aria-label="heart" />
        )}
      </span>
    </button>
  );
};
